module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "video-card"
  }, [_c('v-flex', {
    staticClass: "video-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "video-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "video-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  }), _vm._v(" "), (_vm.$store.state.auth.user) ? _c('v-flex', {
    staticClass: "video-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    },
    on: {
      "click": function($event) {
        _vm.viewStream()
      }
    }
  }, [_c('v-btn', {
    staticClass: "green px-2 live-video-btn",
    attrs: {
      "dark": "",
      "round": ""
    }
  }, [_c('v-icon', [_vm._v("videocam")]), _vm._v(" "), (_vm.item.view_price > 0) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.view_price)))]) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("Broadcast started"), _c('br'), _vm._v(_vm._s(_vm._f("formatDateFromNow")(_vm.item.started_at)))])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "video-detail",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "video-name"
  }, [_c('span'), _vm._v("Broadcasting Live Now")]), _vm._v(" "), _c('p', {
    staticClass: "video-user-name"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.owner.slug
    }
  }, [_vm._v(_vm._s(_vm.owner.username))])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3119408","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/videocard.vue
// module id = 1829
// module chunks = 180